module.exports = __webpack_public_path__ + "static/media/rr-1.921e82b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/rr-1.png
// module id = 119
// module chunks = 0